import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { CatalogoTipoDireccionDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class CatalogoTipoDireccionService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getCatalogoTipoDireccionService(): Observable<BodyListResponse<CatalogoTipoDireccionDTO>> {
    return this.http.get<BodyListResponse<CatalogoTipoDireccionDTO>>(API_URL + '/api/v1/catalogoTipoDireccion/todos');
  }

  guardarCatalogoTipoDireccionService(catalogoTipoDireccionDTO: CatalogoTipoDireccionDTO): Observable<CatalogoTipoDireccionDTO> {
    return this.http.post<CatalogoTipoDireccionDTO>(API_URL + '/api/v1/catalogoTipoDireccion', catalogoTipoDireccionDTO);
  }

  getCatalogoTipoDireccionPorCodigoCatalogoTipoDireccionService(codigoCatalogoTipoDireccion: string): Observable<BodyResponse<CatalogoTipoDireccionDTO>> {
    return this.http.get<BodyResponse<CatalogoTipoDireccionDTO>>(API_URL + '/api/v1/catalogoTipoDireccion/' + codigoCatalogoTipoDireccion);
  }
}
